import React, { useRef } from "react";
import { useHistory } from "react-router-dom";
import { Grid } from "@mui/material";
import IconGroupHeader from "@icoach/nonMember/components/IconGroupHeader";
import { NON_MEMBER_ROUTER } from "@icoach/router/routerPath";
import { Typography, Button, TextField, SelectField, MenuItem, Stack, Chip, Box } from "@curves/ui-base";
import { SourceTypeSelectField } from "@icoach/components/mutipleSelectField/";
import { ReadTextField, EmployeeSelect } from "@icoach/components/";
import { refIsRequiredError } from "@util/utils";
import { displayDateText } from "@util/moment";
import useCustomerApi from "@apis/useCustomerApi";

const ProspectInformationBox = React.forwardRef((props, ref) => {
	const { sourceData = {} } = props;
	const { cellPhone, customerID, customerName, introducer, notes, requiredType, sourceType, sourceTag, employeeID, resource, isValid, registrationDate } = sourceData;
	const { putCustomersInfoApi } = useCustomerApi();
	const history = useHistory();
	const nameRef = useRef(null);
	const phoneRef = useRef(null);
	const originRef = useRef(null);
	const needsRef = useRef(null);
	const coachRef = useRef(null);
	const introducerRef = useRef(null);
	const noteRef = useRef(null);

	const handleBackToOverviewOnClick = () => redirectTablePage();

	const handleUpdateClick = () => {
		if (!refIsRequiredError(nameRef, phoneRef, originRef, needsRef, introducerRef, noteRef)) {
			let originInfo = originRef.current.getResult();
			const params = {
				...originInfo,
				name: nameRef.current.getResult(),
				cellPhone: phoneRef.current.getResult(),
				requiredType: needsRef.current.getResult(),
				introducer: introducerRef.current.getResult(),
				notes: noteRef.current.getResult(),
				employeeID: coachRef.current.getResult(),
			};
			putProspectDataApi(params);
		}
	};

	const redirectTablePage = () => history.push(NON_MEMBER_ROUTER.PROSPECT.OVERVIEW);

	const putProspectDataApi = async params => {
		const resp = await putCustomersInfoApi(customerID, params);
		if (resp) redirectTablePage();
	};

	const { sourceTypes: sourceOptions = [], requiredTypes: requiredOptions = [], coachOptions: employeeOptions = [] } = resource;

	return (
		<React.Fragment>
			<Stack alignItems="center" justifyContent="space-between">
				<Stack alignItems="center">
					<Typography variant="h5">名單資料</Typography>
					<Chip className="ml-3" label={isValid ? "有效" : "無效"} color={isValid ? "success" : "warning"} />
				</Stack>
				<Box>
					<IconGroupHeader
						viewIconArray={["appointment", "contact", isValid ? "invalid" : "", "remove"]}
						rowsData={[{ ...sourceData, displayTypeText: "名單" }]}
						peopleID={customerID}
						urls={{
							apo: NON_MEMBER_ROUTER.CUSTOMER.GET_ADD_PATH(customerID),
						}}
						dialogProps={{
							remove: { refreshParams: ["successDelete", redirectTablePage] },
						}}
					/>
				</Box>
			</Stack>
			<Grid container spacing={3}>
				<Grid item xs={6}>
					<TextField label="姓名" ref={nameRef} defaultValue={customerName} fullWidth required />
				</Grid>
				<Grid item xs={6}>
					<TextField label="手機" ref={phoneRef} defaultValue={cellPhone} fullWidth required />
				</Grid>
				<SourceTypeSelectField ref={originRef} defaultSourceType={sourceType || ""} defaultSourceTag={sourceTag || ""} options={sourceOptions} gridSize={12} />
				<Grid item xs={6}>
					<SelectField ref={needsRef} label="需求" defaultValue={requiredType || ""} displayEmpty fullWidth>
						<MenuItem disabled value="">
							<em>請選擇</em>
						</MenuItem>
						{requiredOptions.map(({ text, value, disabled }) => (
							<MenuItem value={value} key={text} disabled={disabled}>
								{text}
							</MenuItem>
						))}
					</SelectField>
				</Grid>
				<Grid item xs={6}>
					<TextField label="介紹人" ref={introducerRef} defaultValue={introducer} fullWidth />
				</Grid>
				<Grid item xs={6}>
					<EmployeeSelect ref={coachRef} options={employeeOptions} label="擔當" name="employeeID" defaultValue={employeeID} fullWidth required />
				</Grid>
				<Grid item xs={6}>
					<ReadTextField label={"登錄日期"} textProps={{ className: "bg-white" }}>
						{displayDateText(registrationDate)}
					</ReadTextField>
				</Grid>
				<Grid item xs={12}>
					<TextField label="備註" ref={noteRef} multiline rows={4} defaultValue={notes} fullWidth />
				</Grid>
			</Grid>
			<Stack justifyContent="end" spacing={2} className="mt-4">
				<Button variant="outlined" color="secondary" width={16} onClick={handleBackToOverviewOnClick}>
					返回名單清單頁
				</Button>
				<Button variant="contained" color="secondary" width={13} onClick={handleUpdateClick}>
					更新資料
				</Button>
			</Stack>
		</React.Fragment>
	);
});

export default ProspectInformationBox;
